import { render, staticRenderFns } from "./CoozzySaleIcon.vue?vue&type=template&id=0c10f18e&scoped=true"
import script from "./CoozzySaleIcon.vue?vue&type=script&lang=js"
export * from "./CoozzySaleIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzySaleIcon.vue?vue&type=style&index=0&id=0c10f18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c10f18e",
  null
  
)

export default component.exports